import { test } from 'blue-tape';

import createManifest from './manifest';

test('unit :: manifest :: default', (assert) => {
  const items = [{
    name: 'item-name',
    zip: '/item/path/package.zip',
  }];
  const name = 'my-collection';
  const manifest = createManifest(items, name);
  const provisioningItem = manifest.provisioningItems[0];

  assert.equal(manifest.name, name, 'uses the provided name for the manifest');
  assert.equal(provisioningItem.itemType, 'catalog', 'uses default itemType of "catalog"');
  assert.equal(provisioningItem.name, 'item-name', 'uses item name for provisioning item name');
  assert.equal(provisioningItem.location, 'package.zip', 'extracts the filename of the package');
  assert.end();
});

test('unit :: manifiest :: content-repository', (assert) => {
  const items = [{
    name: 'foo',
    zip: '/some/zip.zip',
    type: 'contentRepository',
  }];
  const manifest = createManifest(items, 'my-collection');
  const provisioningItem = manifest.provisioningItems[0];

  assert.equal(provisioningItem.itemType, 'contentRepository',
    'uses itemType of "contentRepository" for content repository items');
  assert.end();
});
